import BelanjaService from '@/services/belanja';
import { userHaveRoles } from "@/services/utilities"

export default {
	namespaced: true,
	state: {
	},

	getters: {
		async getBelanja({ commit, state, getters, dispatch }) {
			try {
				let response
				let responseCategory = await BelanjaService.getSubmissionCategoryByName('BELANJA');
				if(!responseCategory || !responseCategory.data.length){
					return []
				}
				if (userHaveRoles(["accountant"]) || userHaveRoles(["admin"]) || userHaveRoles(["entity"]) || userHaveRoles(["purchasing"])) {
					response = await BelanjaService.getBelanjaCompany(responseCategory.data[0].id)
				} else {	
					response = await BelanjaService.getBelanjaUser(responseCategory.data[0].id)
				}

				return response.data ? response.data.data : []
			} catch (e) {
				console.log(e)
			}
		}
	},

	actions: {
		async createBelanja({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await BelanjaService.createBelanja({
					...payload,
					type: 'PENGELUARAN',
					category_id: "BELANJA",
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateBelanja({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				if (!userHaveRoles(["admin","accountant","stockiest"])) {
					payload.status = 'PENDING'
				}
				response = await BelanjaService.updateBelanja(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateStatusBelanja({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await BelanjaService.updateStatusBelanja(payload.id, {
					...payload
				})
				return response
			} catch (e) {
				console.log(e);
			}
		},
		async deleteBelanja({ commit, state, getters, dispatch }, id) {
			try {
				const response = await BelanjaService.deleteBelanja(id)
				return response
			} catch (e) {
			}
		},
		async filterBelanja({ commit, state, getters, dispatch }, payload) {
			try {
				let responseCategory = await BelanjaService.getSubmissionCategoryByName('BELANJA')
				payload.condition.category_id = responseCategory.data[0].id
				let response = await BelanjaService.filterBelanja(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		} 
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
